export const PLAN_MANAGEMENT_V2 = 'plans-v2'
export const PLAN_OVERRIDES = `${PLAN_MANAGEMENT_V2}/overrides`

export const planReviewPath = (id: string) =>
  `/${PLAN_MANAGEMENT_V2}/${id}/review`
export const planOverridesPath = () => `/${PLAN_OVERRIDES}`
